/*
 *
 * RecoveryAttemptsExceededModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 17-Oct-2024
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.recovery.attempts.excedeed.modal.title'
      defaultMessage='Impossibile impostare la nuova<br/> password'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.recovery.attempts.excedeed.modal.description'
      defaultMessage='Hai esaurito i tentativi di reimpostazione nuova password per oggi.<br/> Riprova tra 24 ore.'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.okUnderstood'
      defaultMessage='Ok, ho capito'
    />
  )
}

export default formattedMessage
